const proposalRequestsConstantsAR = {
  proposalRequestsPageTitle: 'طلبات عروض الأسعار',
  proposalRequestsBreadcrumbs: 'طلبات عروض الأسعار',
  proposalRequestsTableTitleRequestsId: 'معرف طلبات عروض الأسعار',
  proposalRequestsTableTitleDate: 'التاريخ',
  proposalRequestsTableTitleUsername: 'إسم المستخدم',
  proposalRequestsTableTitleCompanyName: 'إسم الجهة',
  proposalRequestsTableTitleStatus: 'الحالة',
  totalProposalRequestItems: 'طلبات عروض الأسعار',

  newQuoteStatus: 'طلب عرض جديد',
  pendingQuoteStatus: 'قيد الانتظار',
  acceptedQuoteStatus: 'مقبول',
  rejectedQuoteStatus: 'مرفوض/ملغى',
};

export default proposalRequestsConstantsAR;
